import { makeStyles } from '@mui/styles';

export const useStylesTabs = makeStyles((theme) => ({
    root: {
        position: 'relative',
        backgroundColor: theme.palette.neutral[50],
    },
    scrollButtons: {
        color: theme.palette.secondary.main,
    },
    tabList: {
        background: theme.palette.neutral[50],
        opacity: '1',
        width: '100% !important',

        '& button': {
            background: 'unset',
            width: '100%',
        },
        '& button[aria-selected="true"]': {
            fontWeight: theme.typography.fontWeightBold,
        },
        '& button[role="tab"]': {
            paddingBottom: 0,
        },
    },
}));
